import type { LeaguesList } from '@library/types/leagues';

export const mapNamesToIds = (
  leaguesList: LeaguesList,
  names: Array<string>
): Array<number> => {
  const nameToIdMap = new Map(
    leaguesList.map(({ name, id }) => [name.toUpperCase(), Number(id)])
  );
  const result: Array<number> = [];

  names.forEach((name) => {
    const id = nameToIdMap.get(name.toUpperCase());
    if (id !== undefined) {
      result.push(id);
    }
  });

  return result;
};
